export default __webpack_public_path__ + "static/media/download.76f5345c.svg";